import { viperApi } from '@/services/viper-api'

export const myAccountService = {
  basePath: () => '/my-account',

  myAccount() {
    return viperApi.get(this.basePath()).then(({ data }) => data)
  },

  featureFlags(organizationId) {
    const query = organizationId ? `?organizationId=${organizationId}` : ''
    return viperApi.get(`${this.basePath()}/feature-flags${query}`).then(({ data }) => data)
  }
}
